/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrregSearchItem
 */
export interface BrregSearchItem {
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    organisationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    organisationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    organisationCompanyType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    postalCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    municipalityNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    municipality?: string | null;
    /**
     * 
     * @type {any}
     * @memberof BrregSearchItem
     */
    countyNumber?: any | null;
    /**
     * 
     * @type {string}
     * @memberof BrregSearchItem
     */
    county?: string | null;
}

/**
 * Check if a given object implements the BrregSearchItem interface.
 */
export function instanceOfBrregSearchItem(value: object): value is BrregSearchItem {
    return true;
}

export function BrregSearchItemFromJSON(json: any): BrregSearchItem {
    return BrregSearchItemFromJSONTyped(json, false);
}

export function BrregSearchItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrregSearchItem {
    if (json == null) {
        return json;
    }
    return {
        
        'organisationNumber': json['organisationNumber'] === undefined ? undefined : json['organisationNumber'] === null ? null : json['organisationNumber'],
        'organisationName': json['organisationName'] === undefined ? undefined : json['organisationName'] === null ? null : json['organisationName'],
        'organisationCompanyType': json['organisationCompanyType'] === undefined ? undefined : json['organisationCompanyType'] === null ? null : json['organisationCompanyType'],
        'address': json['address'] === undefined ? undefined : json['address'] === null ? null : json['address'],
        'postalCode': json['postalCode'] === undefined ? undefined : json['postalCode'] === null ? null : json['postalCode'],
        'postalCity': json['postalCity'] === undefined ? undefined : json['postalCity'] === null ? null : json['postalCity'],
        'municipalityNumber': json['municipalityNumber'] === undefined ? undefined : json['municipalityNumber'] === null ? null : json['municipalityNumber'],
        'municipality': json['municipality'] === undefined ? undefined : json['municipality'] === null ? null : json['municipality'],
        'countyNumber': json['countyNumber'] === undefined ? undefined : json['countyNumber'] === null ? null : json['countyNumber'],
        'county': json['county'] === undefined ? undefined : json['county'] === null ? null : json['county'],
    };
}

export function BrregSearchItemToJSON(json: any): BrregSearchItem {
    return BrregSearchItemToJSONTyped(json, false);
}

export function BrregSearchItemToJSONTyped(value?: BrregSearchItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organisationNumber': value['organisationNumber'],
        'organisationName': value['organisationName'],
        'organisationCompanyType': value['organisationCompanyType'],
        'address': value['address'],
        'postalCode': value['postalCode'],
        'postalCity': value['postalCity'],
        'municipalityNumber': value['municipalityNumber'],
        'municipality': value['municipality'],
        'countyNumber': value['countyNumber'],
        'county': value['county'],
    };
}

